export const SVGElementToCollisionWeight: { [key: string]: number } = {
  ["text"]: 10,
  ["tspan"]: 10,
  ["rectangle"]: 5,
  ["circle"]: 5,
  ["ellipse"]: 5,
  ["default"]: 2,
};
